"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLabProcedures = createLabProcedures;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    labProcedures: {
        id: "dashboard.lab_procedures",
        defaultMessage: "Laborvizsgálatok"
    },
    fvs: {
        id: "dashboard.fvs",
        defaultMessage: "WBC"
    },
    haemoglobin: {
        id: "dashboard.haemoglobin",
        defaultMessage: "HGB"
    },
    got: {
        id: "dashboard.got",
        defaultMessage: "GOT"
    },
    gpt: {
        id: "dashboard.gpt",
        defaultMessage: "GPT"
    },
    ggt: {
        id: "dashboard.ggt",
        defaultMessage: "GGT"
    },
    serumGlucose: {
        id: "dashboard.serum_glucose",
        defaultMessage: "VC"
    }
};
function createLabProcedures(intl, { events }) {
    const fvs = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.fvs,
        query: queries_1.queries.fvs
    });
    const haemoglobin = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.haemoglobin,
        query: queries_1.queries.haemoglobin
    });
    const got = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.got,
        query: queries_1.queries.got
    });
    const gpt = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.gpt,
        query: queries_1.queries.gpt
    });
    const ggt = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.ggt,
        query: queries_1.queries.ggt
    });
    const serumGlucose = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.serumGlucose,
        query: queries_1.queries.serumGlucose
    });
    const content = (0, shared_1.createSectionContent)([
        fvs,
        haemoglobin,
        got,
        gpt,
        ggt,
        serumGlucose
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.labProcedures, content });
}
